<template>
  <BFormGroup :state="validation">
    <div class="d-flex">
      <BFormCheckbox
          :id="`checkbox-input-${data.key}`"
          :model-value="modelValue"
          :state="validation"
          :required="data.mandatory"
          :class="{'is-invalid' : data.mandatory && !modelValue && isSubmitted}"
          @update:model-value="$emit('update:modelValue', $event)"
      >
      </BFormCheckbox>
      <label :label-for="`checkbox-input-${data.key}`" v-html="makeLinkTargetBlank(translatedText(data.text))"/>
    </div>
  </BFormGroup>
</template>

<script setup>
import {inputStatus} from "@/domain/pform/validations";
import {fieldTypes} from "@/domain/pform/fields";
import {computed} from "vue";
import {translate} from "@/domain/utils/translations";

defineEmits(['update:modelValue'])

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  lang: {
    type: String,
    required: true
  },
  modelValue: {
    type: Boolean,
    required: true
  },
  isSubmitted: {
    type: Boolean,
    default: false
  }
})

const makeLinkTargetBlank = (text) => text ? text.replace(/href="([^"]*)"/g, 'href="$1" target="_blank"') : ''

const validation = computed(() => {
  return inputStatus(fieldTypes.CONSENT, props.data.mandatory, props.modelValue, props.isSubmitted)
})

const translatedText = (field) => translate(field, props.lang)

</script>